import globalTheme from 'Assets/js/components/globalTheme';
import { find, findKey, map } from 'lodash-es';

const markets = {
  all: () => {
    const allMarkets = map(globalTheme.markets(), (item) => item.country_code);
    return [
      'IE',
      'GB',
      ...allMarkets.filter((code) => code !== 'IE' && code !== 'GB')
    ];
  },
  has: (market) => {
    const found = find(
      globalTheme.markets(),
      (item) => item.country_code === market
    );
    return !!found;
  },
  getCountryName: (market) => {
    const found = find(
      globalTheme.markets(),
      (item) => item.country_code === market
    );
    return found?.name ?? null;
  },
  asCookieLabel: (market) => {
    const theMarket = find(
      globalTheme.markets(),
      (item) => item.country_code === market
    );
    return `${theMarket.currency} - ${theMarket.name}`;
  },
  getCountryLocale: (market) => {
    const found = findKey(
      globalTheme.markets(),
      (item) => item.country_code === market
    );
    return found ?? null;
  },
  localeToCountryCode: (marketLocale, defaultValue = null) => {
    const data = globalTheme.markets();
    return data[marketLocale] ? data[marketLocale].country_code : defaultValue;
  },
  getCurrencySymbol(currencyCode) {
    return (0)
      .toLocaleString(undefined, { style: 'currency', currency: currencyCode })
      .replace(/[\d.,\s]/g, '')
      .trim();
  },
  getMarketCurrencyCode(market) {
    const theMarket = find(
      globalTheme.markets(),
      (item) => item.country_code === market
    );
    return theMarket ? theMarket.currency : null;
  },
  getMarketSelectLabel(market) {
    const theMarket = find(
      globalTheme.markets(),
      (item) => item.country_code === market
    );
    return theMarket
      ? `${this.getCurrencySymbol(theMarket.currency)} - ${theMarket.currency}`
      : null;
  },
  getMarketSelectorLabel(market) {
    const theMarket = find(
      globalTheme.markets(),
      (item) => item.country_code === market
    );
    return theMarket
      ? `${theMarket.name} - ${this.getCurrencySymbol(theMarket.currency)}`
      : null;
  }
};

export default markets;
